module.exports = __webpack_public_path__ + "static/media/button_check.6c890267.svg";